module.exports = __webpack_public_path__ + "media/11_3.7ea4d436.wav";